export const iconFontAwesomeSocialBell = (
	<i className="fa-solid fa-bell"></i>
);
